// Mutations
export const SETMINIMIZERAIDEVENT = 'SETMINIMIZERAIDEVENT';
export const FOCUSRAIDEVENT = 'FOCUSRAIDEVENT';
export const RESETRAIDEVENTS = 'RESETRAIDEVENTS';
export const SHOWTODAYSRAIDEVENTS = 'SHOWTODAYSRAIDEVENTS';

// Actions
export const ADDRAIDEVENT = 'ADDRAIDEVENT';
export const EDITRAIDEVENT = 'EDITRAIDEVENT';
export const REMOVERAIDEVENT = 'REMOVERAIDEVENT';

import db from '../../firebase/firebase'
import { getTimeAsMinutes, insertByComparison } from '../../functions/general'
import { compareEvents } from '../../functions/raideventfunctions'
import {
  removeBound,
  updateBound } from '../helpers/binding'
import { snapshot2object } from '../helpers/general';
import { generateUpdatesForObject } from '../helpers/updates'

export default {
  state: () => ({
    raidevents: [],
    minimizedRaidEvents: {},
  }),

  getters: {
  },

  mutations: {
    // addBoundRaidEvent: ( state, { snapshot } ) => addBound( state.unsortedraidevents, snapshot ),
    addBoundRaidEvent: ( state, { snapshot, special } ) => {

      // Get raidduration from the selected destination
      let raidduration = special
      if( !raidduration ) raidduration = 180
      
      // Load the raidevent from the snapshot and apply raidduration
      let raidevent = snapshot2object( snapshot )
      if( raidevent.date && raidevent.time ) {
        let timeOfDayInMillis = getTimeAsMinutes( raidevent.time ) * 60 * 1000
        raidevent.startDT = raidevent.date + timeOfDayInMillis
        raidevent.endDT = raidevent.startDT + raidduration * 60 * 1000

        // Check which existing events overlap with the new
        raidevent.overlappingEvents = []
        for( let raidevent2 of state.raidevents )
        {
          if( raidevent2.startDT && raidevent2.endDT
              && raidevent.startDT < raidevent2.endDT // Overlap check
              && raidevent2.startDT < raidevent.endDT ) {
            raidevent.overlappingEvents.push( raidevent2 )
            raidevent2.overlappingEvents.push( raidevent )
          }
        }
      }

      // Insert raidevent at the right place
      insertByComparison( state.raidevents, raidevent, compareEvents )

    },
    removeBoundRaidEvent: ( state, { snapshot } ) => removeBound( state.raidevents, snapshot ),
    updateBoundRaidEvent: ( state, { snapshot } ) => updateBound( state.raidevents, snapshot ),

    [RESETRAIDEVENTS] ( state ) {
      state.raidevents = []
      state.minimizedRaidEvents = {}
    },

    [SETMINIMIZERAIDEVENT] ( state, raidevent ) {
      state.minimizedRaidEvents[ raidevent['.key'] ] = !state.minimizedRaidEvents[ raidevent['.key'] ]
    },

    [FOCUSRAIDEVENT] ( state, raidevent ) {
      let newminimized = {}
      for( let e of state.raidevents ) {
        if( e['.key'] != raidevent['.key'] ) {
          newminimized[ e['.key'] ] = true
        }
      }
      state.minimizedRaidEvents = newminimized
    },
    [SHOWTODAYSRAIDEVENTS] ( state ) {
      let newminimized = {}
      for( let raidevent of state.raidevents ) {
        let now = Date.now()
        if( raidevent.date
            && ( now < raidevent.date
                 || now > raidevent.date + 24 * 60 * 60 * 1000 ) ) {
          newminimized[ raidevent['.key'] ] = true
        }
      }
      state.minimizedRaidEvents = newminimized
    },

  },

  actions: {
    [ADDRAIDEVENT] ( context, { lockout, neweventid, raidevent } ) {
      if( lockout ) {
        var newevent = { name: neweventid };
        Object.assign( newevent, raidevent )

        return db.ref( 'lockouts/' + lockout['.key'] +
                       '/raidevents/' + neweventid ).set( newevent )
      }
    },
    [EDITRAIDEVENT] ( context, { lockout, raidevent, newvalues } ) {
      if( lockout && raidevent ) {
        let updates = generateUpdatesForObject(
          'lockouts/' + lockout['.key'] +
          '/raidevents/' + raidevent['.key'] + '/', newvalues )
      
        return db.ref().update( updates )
      }
    },
    [REMOVERAIDEVENT] ( { rootState }, { lockout, raidevent } ) {
      if( lockout ) {
        var updates = {}
        updates[ '/raidevents/' + raidevent['.key'] ] = null

        // Remove (completely delete) all signups for this event
        let eventsigns = rootState.signups.signups.filter( s => s.eventid == raidevent['.key'] )
        for( var sign of eventsigns ) {
          updates[ '/signups/' + sign['.key'] ] = null
        }

        // Remove event from all teams
        let teaminevent = rootState.teams.teams.filter( t => t.raidevents &&
                                                        t.raidevents[ raidevent['.key'] ] )
        for( var team of teaminevent ) {
          updates[ '/teams/' + team['.key'] +
                   '/raidevents/' + raidevent['.key'] ] = null
        }

        return db.ref( 'lockouts/' + lockout['.key'] ).update( updates )
      }
    },
  },
}